export const AIVoicesSection = () => {
  return (
    <section className="py-20 px-4 bg-gray-100">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
              AI-Stimmen, die klingen wie echtes Kino fürs Ohr
            </h2>
          </div>

          {/* Two columns of text */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                Vergiss alles, was du bisher über künstliche Stimmen gehört hast. Mit Audio Empire bekommst du Zugang zu den neuesten Native AI Speech Voices – Stimmen, die Emotionen wecken, Gänsehaut auslösen und deine Hörer vom ersten Satz an fesseln.
              </p>
              <p className="text-gray-600 leading-relaxed text-lg">
                Früher konnte man sofort erkennen, wenn eine Stimme künstlich war – unnatürlich, leblos, manchmal so schlecht, dass Hörbücher gar nicht veröffentlicht wurden oder reihenweise schlechte Bewertungen kassierten. Das ändert sich jetzt.
              </p>
            </div>

            <div className="space-y-6">
              <p className="text-gray-600 leading-relaxed text-lg">
                <strong>Die AI-Stimmen klingen authentischer als viele menschliche Sprecher. Sie atmen, betonen und interpretieren wie ein Profi – und liefern ein Hörerlebnis, das deine Geschichten, Kurse oder Botschaften auf ein ganz neues Level hebt.</strong>
              </p>
              <p className="text-gray-600 leading-relaxed text-lg">
                Audio Empire bringt dir die modernste Sprach-KI direkt ins Ohr. Das Ergebnis: Ein Hörbuch-Erlebnis, das besser ist als „echt".
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};